interface NoLayoutProps {
  children: React.ReactNode;
}

// Intended as a null object pattern container (i.e. a null wrapper)
export const NoLayout = ({ children }: NoLayoutProps) => {
  return <>{children}</>;
};
